




























































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import FunctionalCalendar from "vue-functional-calendar/src/components/FunctionalCalendar.vue";
import moment from "moment";
import { Time } from "@/services/posts/types";
import { calendarConfigs } from "@/services/functional-calendar";
import { checkBackgroundColor } from "./previewHelper";
import { Option } from "@/services/common/types";
import { getSolutionsForContent } from "@/services/solutions/solutionService";
import vSelect from "vue-select";
// css
import "vue-select/dist/vue-select.css";
import { Solution } from "@/services/solutions/types";
import i18n from "@/i18n";

@Component({
    components: {
        vSelect,
        FunctionalCalendar
    }
})
export default class PreviewModalHeader extends Vue {
    @Prop() private scale!: number;
    @Prop() private fitScale!: number;
    @Prop() title!: string;
    @Prop({ default: "#" }) fullScreenRoute!: string;
    @Prop({ default: false }) simple!: boolean; // If this is true we simplify the preview by hiding some options (used by website post)
    @Prop({ default: false }) isChannelPreview!: boolean;
    @Prop({ default: false }) isChannelGroupPreview!: boolean;
    @Prop() contentId!: string;

    // local
    date = new Date().toDateString();
    calendar = {};
    time = moment(new Date()).format("HH:mm").toString();
    hours = Time;
    localScale = this.scale;
    bgColor = "#ffffff";
    scalePercentages = [25, 50, 75, 100, 125, 150, 200];
    keepZoom = false;
    solutionsOptions = [] as Array<Option>;
    solutions = [] as Array<Solution>;
    selectedSolutionOption = null as Option | any;
    backToContent = {
        id: "",
        text: `${this.isChannelPreview ? i18n.t("common.channel") : i18n.t("channelGroups.channelGroup")}: ${this.title}`
    } as Option;

    // Watchers
    @Watch("scale")
    onPropertyChanged() {
        this.localScale = this.scale;
    }

    // lifecycle hooks
    mounted() {
        this.$emit("changeBg", this.bgColor);
        var date = new Date();
        (this.$refs.dateTimeCalendar as any).clickDay({
            day: date.getDate(),
            date: `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`,
            isMarked: true
        });

        if (this.isChannelPreview || this.isChannelGroupPreview) {
            getSolutionsForContent(this.contentId).then(response => {
                this.solutions = response;
                this.solutionsOptions = response.map(x => ({
                    id: x.id,
                    text: `${i18n.t("common.solution")}: ${x.name}`
                }));
            });
        }
    }

    // methods
    loadSolutionPreview() {
        if (!this.selectedSolutionOption || this.selectedSolutionOption.id === "") {
            this.$emit("clearSolutionPreview");
            this.selectedSolutionOption = null as Option | any;
            this.solutionsOptions.shift();
        } else {
            this.$emit("loadSolutionPreview", this.solutions.find(i => i.id === this.selectedSolutionOption.id));
            if (!this.solutionsOptions.find(i => i.id === "")) {
                this.solutionsOptions.unshift(this.backToContent);
            }
        }
    }

    scaleUp() {
        this.localScale += 0.1;
        this.$emit("onScale", this.localScale);
    }

    scaleDown() {
        if (this.localScale - 0.1 >= 0) {
            this.localScale -= 0.1;
            this.$emit("onScale", this.localScale);
        }
    }

    scaleFit() {
        this.$emit("scaleFit");
    }

    changeBackground() {
        if (this.bgColor === "#ffffff") this.bgColor = "#999999";
        else this.bgColor = "#ffffff";
        this.$emit("changeBg", this.bgColor);
    }

    dayClicked(selected: any) {
        const dateParts = selected.date.split("/");
        // month is 0-based, that's why we need dataParts[1] - 1
        const dateObject = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);
        this.date = dateObject.toDateString();
        this.$emit("render", this.dateTime, this.keepZoom);
        this.keepZoom = true;
    }

    getFromDateLabel() {
        return this.$i18n.d(new Date(this.date), "short");
    }

    getTimeLabel() {
        return moment(this.fromTime, "hh mm").format("HH:mm");
    }

    validateHhMm(input: string) {
        return /^([0-1]?[0-9]|2[0-4]):([0-5][0-9])(:[0-5][0-9])?$/.test(input);
    }

    checkBackgroundColor(renderChannel: any) {
        checkBackgroundColor(renderChannel, this.changeBackground);
    }

    // computed

    get dateTime() {
        return `${this.date} ${this.time}`;
    }

    get fromTime() {
        return this.time;
    }

    set fromTime(time: any) {
        if (time && this.validateHhMm(time)) {
            this.time = time;
            this.$emit("render", this.dateTime, this.keepZoom);
            this.keepZoom = true;
        }
    }

    get scalePercent() {
        return Math.round(this.localScale * 100);
    }

    set scalePercent(value: number) {
        this.localScale = value / 100;
        this.$emit("onScale", this.localScale);
    }

    get calendarConfigs() {
        return calendarConfigs();
    }
}
